import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const ProductsList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  columnVisibilityModel,
  onRowClick,
}) => {

  const [pageSize, setPageSize] = React.useState(20);
  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 360px)' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '재고 리스트' },
          }}

          initialState={{ pinnedColumns: { right: ['actions'] } }}

          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          onRowClick={onRowClick}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
          sx={onRowClick ? { cursor: 'pointer' } : {}}
        />
      </div>
    </div>
  );
};


export default ProductsList